/**
 * Tom
 * request请求并发控制
 */
import requestHttp from './request'

class SuperTask {
  constructor(count = 5) {
    this.parallelCount = count; //并发数量
    this.runningCount = 0; //运行数量
    this.tasks = []; //任务列表
  }
  add(task) {
    return new Promise((resolve, reject) => {
      this.tasks.push({
        task,
        resolve,
        reject
      })
      this._run()
    })
  }
  _run() {
    while (this.runningCount < this.parallelCount && this.tasks.length) {
      const {
        task,
        resolve,
        reject
      } = this.tasks.shift();
      this.runningCount++;
      task().then(resolve, reject).finally(() => {
        this.runningCount--;
        this._run()
      })
    }
  }
}

const superTask = new SuperTask()

export default function request(obj) {
  return superTask.add(() => {
    return requestHttp(obj)
  })
}
